import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { moduleMaster } from 'src/app/Models/BasicForms/moduleMaster';
import { Role } from 'src/app/Models/Commonmodule/role';
import { ApiService } from 'src/app/Service/api.service';
import { ModuleFeatureViewComponent } from '../../ModuleFeatureView/module-feature-view/module-feature-view.component';

@Component({
  selector: 'app-module-mapping',
  templateUrl: './module-mapping.component.html',
  styleUrls: ['./module-mapping.component.css']
})

export class ModuleMappingComponent implements OnInit {
  @Input() drawerClose: Function;
  @Input() data: moduleMaster;
  @Input() mappingData: [];

  TASK_CATEGORY_ID = 0;
  USER_ID = 1;
  IS_ACTIVE = true;
  searchText = "";

  constructor(private notificationSer: NzNotificationService, public _apiService: ApiService) { }

  ngOnInit(): void {
    this.loadAllCategories();
    this.loadRoles();
  }

  displayFilterBox = false;
  flterBoxVisibleInvisible() {
    this.displayFilterBox = !this.displayFilterBox;
  }

  filterButtonType = "default";
  filterIsAppliedOrNot() {
    // if (this.chillingCenterID.length > 0) {
    //   
    //   this.filterButtonType= "primary";
    // } else {

    //   this.filterButtonType= "default";
    // }
  }

  close() {
    this.drawerClose();
    this.isSpinning = false;
  }

  isSpinning = false;

  save(addNew: boolean) {
    this.isSpinning = true;
    this.gettingAssigneeList();

    this._apiService.addModuleMappingDetails(this.data.ID, this.mappingData).subscribe(successCode => {


      if (successCode['code'] == "200") {
        // this.notificationSer.success("Module Mapping Done Successfully", "");
        // this.isSpinning = false;



        var assigndata = [];
        for (var i = 0; i < this.mappingData.length; i++) {
          if (this.mappingData[i]["IS_ACTIVE"] == 1) {
            assigndata.push(Number(this.mappingData[i]["USER_ID"]));
          }
        }

        // console.log(assigndata, "assigndata");
        this.data.REPORTER_ID = this._apiService.userId;
        this.data.TYPE = 2;
        var dataaa = {
          TYPE: this.data.TYPE,
          REFERENCE_ID: this.data.ID,
          REPORTER_ID: this.data.REPORTER_ID,
          CLIENT_ID: 1,
          ASSIGNEES: assigndata,
        };


        this._apiService.updateTaskSubtasknew(dataaa).subscribe(
          (successCode) => {
            if (successCode["code"] == "200") {
              this.notificationSer.success("Module Mapping Done Successfully", "");
              this.isSpinning = false;
            } else {
              this.notificationSer.error("Failed to Update Feature", "");
              this.isSpinning = false;
            }
          },
          (err) => {
            if (err["ok"] == false) {
              this.notificationSer.error("Server Not Found", "");
              this.isSpinning = false;
            }
          }
        );

        // Update New Assignee
        this.onAssigneeChange();

        if (!addNew) {
          this.drawerClose();

        } else {
          // this.TASK_CATEGORY_ID = 1;
          this.onCategoryChange();
        }
      }

      else {
        this.notificationSer.error("Module Mapping Failed", "");
        this.isSpinning = false;
      }
    });
  }

  assigneeList = [];
  sortedAssigneeList = [];

  preAssigneeList = [];
  newPreAssigneeList = [];
  sortedNewPreAssigneeList = [];

  assigneeListToUpdate = [];

  gettingAssigneeList() {
    this.assigneeList = [];
    this.sortedAssigneeList = [];
    this.preAssigneeList = [];
    this.newPreAssigneeList = [];
    this.sortedNewPreAssigneeList = [];
    this.assigneeListToUpdate = [];



    for (var i = 0; i < this.mappingData.length; i++) {
      if (this.mappingData[i]['IS_ACTIVE'] == 1) {
        this.assigneeList.push(Number(this.mappingData[i]['USER_ID']));
      }
    }

    this.sortedAssigneeList = this.assigneeList.sort((n1, n2) => n1 - n2);


    if (this.data['ASSIGNEE_IDS'] != null) {
      this.preAssigneeList = this.data['ASSIGNEE_IDS'].split(',');
    }

    for (var i = 0; i < this.preAssigneeList.length; i++) {
      this.newPreAssigneeList.push(Number(this.preAssigneeList[i]));
    }

    this.sortedNewPreAssigneeList = this.newPreAssigneeList.sort((n1, n2) => n1 - n2);


    // Getting Unique Element
    let unique1 = this.sortedAssigneeList.filter((o) => this.sortedNewPreAssigneeList.indexOf(o) === -1);
    let unique2 = this.sortedNewPreAssigneeList.filter((o) => this.sortedAssigneeList.indexOf(o) === -1);
    this.assigneeListToUpdate = unique1.concat(unique2);


  }

  onAssigneeChange() {
    this.data.PROJECT_ID = this.data.PROJECT_ID;
    this.data.NAME = this.data.NAME;
    this.data.DESCRIPTION = this.data.DESCRIPTION;
    this.data.ESTIMATED_MANDAYS = this.data.ESTIMATED_MANDAYS;
    this.data.START_DATE = this.data.START_DATE;
    this.data.END_DATE = this.data.END_DATE;
    this.data.STATUS = this.data.STATUS;
    this.data.ESTIMATED_HOURS = 0;
    this.data.ESTIMATED_MINUTES = 0;
    this.data.ESTIMATED_SECONDS = 0;
    this.data.IS_ACTIVE = true;

    this.data.ASSIGNEES = this.assigneeListToUpdate;
    this.data.REPORTER_ID = this._apiService.userId;
    this.data.TYPE = 2;



    if (this.assigneeListToUpdate.length != 0 && this.sortedAssigneeList.length > this.sortedNewPreAssigneeList.length) {
      this._apiService.updateModule(this.data).subscribe(successCode => {

        if (successCode['code'] == "200") {
          this.notificationSer.success("Module Updated Successfully", "");

        } else {
          this.notificationSer.error("Failed to Update Module", "");
        }

      }, err => {


        if (err["ok"] == false) {
          this.notificationSer.error("Server Not Found", "");
        }
      });
    }
  }

  categoryList = [];

  loadAllCategories() {
    this._apiService.getAllCategories(0, 0, 'ID', 'desc', ' and IS_ACTIVE=1').subscribe(categoryData => {
      this.categoryList = categoryData['data'];

    }, err => {

    });
  }

  loadingRecords = false;

  onCategoryChange() {
    this.loadingRecords = true;

    this._apiService.getModuleDetails(this.data.ID, 0).subscribe(data => {
      this.loadingRecords = false;


      this.mappingData = data['data'];

    }, err => {

    });
  }

  roles: Role[];
  roleLoading = false;

  loadRoles() {
    this.roleLoading = true;
    this._apiService.getAllRoles(0, 0, '', '', " and ID not in (1,2)").subscribe(roles => {
      this.roles = roles['data'];
      this.roleLoading = false;

    }, err => {

      this.roleLoading = false;
    });
  }
}
